import Distribuicao from "./Distribuicao";

export default Distribuicao;
